export default __webpack_public_path__ + "static/media/onboarding-classes.495e05e4.svg";